(function () {
    'use strict';

    angular
        .module(app.modules.common.name)
        .config(httpConfig);

    httpConfig.$inject = ['$httpProvider'];
    function httpConfig($httpProvider) {
        $httpProvider.interceptors.push(httpInterceptor);

        httpInterceptor.$inject = ['$q', '$exceptionHandler', app.modules.common.services.storage];
        function httpInterceptor($q, $exceptionHandler, ggStorage) {
            var ERROR_MSG_FMT = "API call failed - {0}\n{1} ({2}) - {3}",
                slice = Array.prototype.slice;

            return { request: request, responseError: responseError };

            function request(config) {
                config.transformResponse = []
                    .concat(config.transformResponse)
                    .map(function (func) { return wrap(func); });

                var bearer = ggStorage.get(ggStorage.keys.member.bearertoken);
                if (bearer && !config.headers['Authorization'])
                    config.headers['Authorization'] = 'Bearer ' + bearer;

                return config;

                function wrap(transformResponse) {
                    return function wrappedTransformResponse(data, headersGetter, status) {
                        return transformResponse.apply(this, slice.call(arguments, 0).concat(config));
                    }
                }
            }
            function responseError(response) {
                if (response.config && response.config.url) {
                    var errorMessage = response.data && response.data.error && response.data.error.message || 'Unknown Error';
                    errorMessage = ERROR_MSG_FMT.format(response.config.url, response.status, response.statusText, errorMessage);
                    $exceptionHandler(errorMessage);
                }

                return $q.reject(response);
            }
        }
    }
})();